import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  collectionGroup,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faEye,
  faReceipt,
  faDollarSign,
  faUsers,
  faClipboardCheck,
  faRotateRight,
  faXmark,
  faBoxOpen,
  faUser,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "../screenstyles/CompleteOrdersList.css";
import { Modal, Box, Typography, Button } from "@mui/material";
interface CompleteOrder {
  id: string;
  userId: string;
  orderId: string;
  path: string;
  orderDocPath: string;

  InstallerId?: string;
  InstallerLocationId?: string;
  locationName?: string;
  PaymentStutes?: string;
  Stutes?: string;
  totalOrderPrice?: number;

  createdAt?: any;
  datetime?: any;
  date?: string;

  [key: string]: any;
}


interface OrderItem {
  id: string;
  code?: string;
  point?: string;
  price?: string;
  productImage?: string;
  productName?: string;
  producttype?: string;
  quantity?: number;
  timestamp?: any;
  totalPrice?: number;
  [key: string]: any;
}

interface BuyerInfo {
  id: string;
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  province?: string;
  accountType?: string;
  profileImageUrl?: string;
  code?: string;
  [key: string]: any;
}
const CompleteOrdersList: React.FC = () => {
  const [orders, setOrders] = useState<CompleteOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const navigate = useNavigate();

  const [detailsModalOpen, setDetailsModalOpen] = useState<boolean>(false);
const [selectedOrder, setSelectedOrder] = useState<CompleteOrder | null>(null);
const [selectedOrderItems, setSelectedOrderItems] = useState<OrderItem[]>([]);
const [selectedBuyer, setSelectedBuyer] = useState<BuyerInfo | null>(null);
const [detailsLoading, setDetailsLoading] = useState<boolean>(false);
  const formatDate = (value: any) => {
    if (!value) return "غير متوفر";

    try {
      if (value?.toDate) {
        return value.toDate().toLocaleString("ar-IQ");
      }

      if (typeof value === "string") {
        return value;
      }

      return "غير متوفر";
    } catch {
      return "غير متوفر";
    }
  };

  const fetchCompleteOrders = async () => {
    setLoading(true);

    try {
      const completeOrdersRef = collectionGroup(db, "CompleteOrder");
      const snapshot = await getDocs(completeOrdersRef);

      const fetchedOrders: CompleteOrder[] = snapshot.docs.map((docSnap) => {
        const data = docSnap.data();

        const parentOrderDoc = docSnap.ref.parent.parent;
const userDoc = parentOrderDoc?.parent.parent;

const orderId = parentOrderDoc?.id || "unknown-order";
const userId = userDoc?.id || "unknown-user";

return {
  id: docSnap.id,
  userId,
  orderId,
  path: docSnap.ref.path,
  orderDocPath: parentOrderDoc?.path || "",
  ...data,
};
      });

    fetchedOrders.sort((a, b) => {
  const getTime = (order: CompleteOrder) => {
    const value = order.datetime || order.createdAt || order.date;

    if (value?.toDate) {
      return value.toDate().getTime();
    }

    if (typeof value === "string") {
      return new Date(value).getTime() || 0;
    }

    return 0;
  };

  return getTime(b) - getTime(a);
});
      console.log("✅ All Complete Orders:", fetchedOrders);
      console.log("✅ Real Complete Orders Count:", fetchedOrders.length);

      setOrders(fetchedOrders);
    } catch (error) {
      console.error("❌ Error fetching complete orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchItemsFromPath = async (basePath: string) => {
  if (!basePath) return [];

  const itemsRef = collection(db, `${basePath}/items`);
  const itemsSnap = await getDocs(itemsRef);

  return itemsSnap.docs.map((itemDoc) => ({
    id: itemDoc.id,
    ...itemDoc.data(),
  })) as OrderItem[];
};

const handleOpenOrderDetails = async (order: CompleteOrder) => {
  setSelectedOrder(order);
  setSelectedOrderItems([]);
  setSelectedBuyer(null);
  setDetailsModalOpen(true);
  setDetailsLoading(true);

  try {
    /**
     * 1) جلب بيانات المشتري
     * حسب مشروعك المستخدمين موجودين في collection اسمها users
     */
    if (order.userId && order.userId !== "unknown-user") {
      const buyerRef = doc(db, "users", order.userId);
      const buyerSnap = await getDoc(buyerRef);

      if (buyerSnap.exists()) {
        setSelectedBuyer({
          id: buyerSnap.id,
          ...buyerSnap.data(),
        } as BuyerInfo);
      }
    }

    /**
     * 2) جلب مواد الطلب
     * نجرب أولاً items داخل CompleteOrder document
     * وإذا لم نجد، نجرب items داخل order document الأب
     */
    let items = await fetchItemsFromPath(order.path);

    if (items.length === 0 && order.orderDocPath) {
      items = await fetchItemsFromPath(order.orderDocPath);
    }

    setSelectedOrderItems(items);
  } catch (error) {
    console.error("Error fetching order details:", error);
  } finally {
    setDetailsLoading(false);
  }
};

const handleCloseOrderDetails = () => {
  setDetailsModalOpen(false);
  setSelectedOrder(null);
  setSelectedOrderItems([]);
  setSelectedBuyer(null);
};
  useEffect(() => {
    fetchCompleteOrders();
  }, []);

  const filteredOrders = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    if (!query) return orders;

    return orders.filter((order) => {
      return (
        order.id?.toLowerCase().includes(query) ||
        order.userId?.toLowerCase().includes(query) ||
        order.locationName?.toLowerCase().includes(query) ||
        order.PaymentStutes?.toLowerCase().includes(query) ||
        order.Stutes?.toLowerCase().includes(query)
      );
    });
  }, [orders, searchQuery]);

  const totalAmount = useMemo(() => {
    return orders.reduce((sum, order) => {
      return sum + Number(order.totalOrderPrice || 0);
    }, 0);
  }, [orders]);

  const uniqueUsersCount = useMemo(() => {
    return new Set(orders.map((order) => order.userId)).size;
  }, [orders]);

  return (
    <div className="complete-orders-page" dir="rtl">
      <div className="complete-orders-hero">
        <div>
          <p className="page-kicker">إدارة الطلبات</p>
          <h1>الطلبات المكتملة</h1>
          <p className="page-description">
            عرض جميع الطلبات الموجودة داخل CompleteOrder مباشرة بدون الاعتماد على بيانات المستخدم.
          </p>
        </div>

        <button className="refresh-button" onClick={fetchCompleteOrders}>
          <FontAwesomeIcon icon={faRotateRight} />
          تحديث البيانات
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">
            <FontAwesomeIcon icon={faReceipt} />
          </div>
          <div>
            <span>عدد الطلبات الحقيقي</span>
            <strong>{orders.length}</strong>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div>
            <span>عدد المستخدمين</span>
            <strong>{uniqueUsersCount}</strong>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div>
            <span>إجمالي المبالغ</span>
            <strong>{totalAmount.toLocaleString()} د.ع</strong>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FontAwesomeIcon icon={faClipboardCheck} />
          </div>
          <div>
            <span>النتائج المعروضة</span>
            <strong>{filteredOrders.length}</strong>
          </div>
        </div>
      </div>

      <div className="orders-toolbar">
        <div className="search-box">
          <FontAwesomeIcon icon={faSearch} />
          <input
            type="text"
            placeholder="ابحث برقم الطلب، User ID، الموقع، حالة الدفع، حالة الطلب..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="orders-panel">
        {loading ? (
          <div className="loading-state">
            <div className="loader"></div>
            <p>جاري تحميل الطلبات...</p>
          </div>
        ) : filteredOrders.length === 0 ? (
          <div className="empty-state">
            <FontAwesomeIcon icon={faReceipt} />
            <h3>لا توجد طلبات</h3>
            <p>لم يتم العثور على طلبات مطابقة لعملية البحث.</p>
          </div>
        ) : (
          <div className="table-wrapper">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>User ID</th>
                  <th>الموقع</th>
                  <th>حالة الدفع</th>
                  <th>حالة الطلب</th>
                  <th>المبلغ</th>
              <th>تاريخ الطلب</th>
                  <th>المسار</th>
                  <th>التفاصيل</th>
                </tr>
              </thead>

              <tbody>
                {filteredOrders.map((order, index) => (
                  <tr key={order.path}>
                    <td>
                      <span className="row-number">{index + 1}</span>
                    </td>

                    <td>
                      <span className="mono-text">{order.id}</span>
                    </td>

                    <td>
                      <span className="mono-text">{order.userId}</span>
                    </td>

                    <td>{order.locationName || "غير متوفر"}</td>

                    <td>
                      <span className="status-pill payment">
                        {order.PaymentStutes || "غير متوفر"}
                      </span>
                    </td>

                    <td>
                      <span className="status-pill order">
                        {order.Stutes || "غير متوفر"}
                      </span>
                    </td>

                    <td>
                      <strong>{Number(order.totalOrderPrice || 0).toLocaleString()} $</strong>
                    </td>

                  <td>{formatDate(order.datetime || order.createdAt || order.date)}</td>

                    <td>
                      <span className="path-text">{order.path}</span>
                    </td>

                    <td>
                      <button
  className="details-button"
  onClick={() => handleOpenOrderDetails(order)}
>
  <FontAwesomeIcon icon={faEye} />
  عرض
</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>


      <Modal
  open={detailsModalOpen}
  onClose={handleCloseOrderDetails}
  className="order-details-modal"
>
  <Box className="order-details-modal-card">
    <div className="order-details-modal-header">
      <div>
        <Typography className="order-details-modal-title">
          تفاصيل الطلب
        </Typography>
        <p className="order-details-modal-subtitle">
          عرض بيانات الطلب، المشتري، والمواد المرتبطة به.
        </p>
      </div>

      <button
        type="button"
        className="order-details-close-btn"
        onClick={handleCloseOrderDetails}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>

    {detailsLoading ? (
      <div className="order-details-loading">
        <div className="loader"></div>
        <p>جاري تحميل تفاصيل الطلب...</p>
      </div>
    ) : selectedOrder ? (
      <>
        <div className="order-details-grid">
          <div className="order-details-section">
            <div className="order-details-section-title">
              <FontAwesomeIcon icon={faReceipt} />
              معلومات الطلب
            </div>

            <div className="order-info-list">
              <div>
                <span>Complete Order ID</span>
                <strong>{selectedOrder.id}</strong>
              </div>

              <div>
                <span>Order ID</span>
                <strong>{selectedOrder.orderId}</strong>
              </div>

              <div>
                <span>User ID</span>
                <strong>{selectedOrder.userId}</strong>
              </div>

              <div>
                <span>حالة الدفع</span>
                <strong>{selectedOrder.PaymentStutes || "غير متوفر"}</strong>
              </div>

              <div>
                <span>حالة الطلب</span>
                <strong>{selectedOrder.Stutes || "غير متوفر"}</strong>
              </div>

              <div>
                <span>InstallerId</span>
                <strong>{selectedOrder.InstallerId || "غير متوفر"}</strong>
              </div>

              <div>
                <span>InstallerLocationId</span>
                <strong>{selectedOrder.InstallerLocationId || "غير متوفر"}</strong>
              </div>

              <div>
                <span>تاريخ الطلب</span>
                <strong>
                  {formatDate(
                    selectedOrder.datetime ||
                      selectedOrder.createdAt ||
                      selectedOrder.date
                  )}
                </strong>
              </div>

              <div>
                <span>إجمالي الطلب</span>
                <strong>
                  {Number(selectedOrder.totalOrderPrice || 0).toLocaleString()} د.ع
                </strong>
              </div>
            </div>
          </div>

          <div className="order-details-section">
            <div className="order-details-section-title">
              <FontAwesomeIcon icon={faUser} />
              بيانات المشتري
            </div>

            {selectedBuyer ? (
              <div className="buyer-card">
                {selectedBuyer.profileImageUrl && (
                  <img
                    src={selectedBuyer.profileImageUrl}
                    alt={selectedBuyer.fullName || "buyer"}
                    className="buyer-image"
                  />
                )}

                <div className="buyer-info">
                  <h3>{selectedBuyer.fullName || "مستخدم بدون اسم"}</h3>
                  <p>{selectedBuyer.phoneNumber || "لا يوجد رقم هاتف"}</p>
                  <p>{selectedBuyer.email || "لا يوجد بريد إلكتروني"}</p>
                  <p>{selectedBuyer.province || "لا توجد محافظة"}</p>
                  <p>{selectedBuyer.accountType || "لا يوجد نوع حساب"}</p>
                  {selectedBuyer.code && <p>Code: {selectedBuyer.code}</p>}
                </div>
              </div>
            ) : (
              <div className="order-details-empty">
                لم يتم العثور على بيانات المشتري.
              </div>
            )}

            <div className="location-box">
              <div className="order-details-section-title small">
                <FontAwesomeIcon icon={faLocationDot} />
                موقع الطلب
              </div>
              <p>{selectedOrder.locationName || "غير متوفر"}</p>
            </div>
          </div>
        </div>

        <div className="order-items-section">
          <div className="order-details-section-title">
            <FontAwesomeIcon icon={faBoxOpen} />
            مواد الطلب
          </div>

          {selectedOrderItems.length === 0 ? (
            <div className="order-details-empty">
              لا توجد مواد داخل هذا الطلب.
            </div>
          ) : (
            <div className="order-items-table-wrapper">
              <table className="order-items-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>الصورة</th>
                    <th>الكود</th>
                    <th>اسم المنتج</th>
                    <th>النوع</th>
                    <th>السعر</th>
                    <th>الكمية</th>
                    <th>النقاط</th>
                    <th>الإجمالي</th>
                    <th>التاريخ</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedOrderItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        {item.productImage ? (
                          <img
                            src={item.productImage}
                            alt={item.productName || item.code || "product"}
                            className="order-item-image"
                          />
                        ) : (
                          "لا توجد صورة"
                        )}
                      </td>

                      <td>
                        <span className="mono-text">{item.code || "غير متوفر"}</span>
                      </td>

                      <td>{item.productName || "غير متوفر"}</td>
                      <td>{item.producttype || "غير متوفر"}</td>
                      <td>{Number(item.price || 0).toLocaleString()} د.ع</td>
                      <td>{item.quantity || 0}</td>
                      <td>{item.point || 0}</td>
                      <td>
                        <strong>
                          {Number(item.totalPrice || 0).toLocaleString()} د.ع
                        </strong>
                      </td>
                      <td>{formatDate(item.timestamp)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <Box className="order-details-modal-actions">
          <Button
            className="order-details-modal-cancel-btn"
            onClick={handleCloseOrderDetails}
          >
            إغلاق
          </Button>
        </Box>
      </>
    ) : null}
  </Box>
</Modal>
    </div>
  );
};

export default CompleteOrdersList;